import TravelersPortal  from "@/views/traveler/TravelerPortal";
//import EditRide  from "@/views/traveler/EditSingleRide";

export default [
	{
		path: "/",
		name: "Travelers",
		component: TravelersPortal,
		meta: {
			requiresAuth: true
		}
	},
	/*{
		path: "/ride/:serviceId/editing",
		name: "Editing",
		component: EditRide,
		meta: {
			requiresAuth: true
		}
	}*/
];
